// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EiQB","colMin":"styles_colMin__1jzTH"};